module.exports = __webpack_public_path__ + "img/DSC_0032.0d8474bc.jpeg";